import Api from './api';

const slug = 'v1/extrinsic';
export default {
  getInfoBadges(lang) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {
        params: {
          language: lang,
        },
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
